import _ from 'lodash';
import FJCreationEditUndoRedoManager from '../../components/FJMainPreview/FJCreationEditPanel/js/FJCreationEditUndoRedoManager';
import { BACKGROUND_TYPE } from '../../components/FJMainPreview/FJCreationEditPanel/js/FJPhotoRemoveBgCanvas';
import {
    FJViewCanvasSingleton,
    MOUSE_EVENT_TYPE,
} from '../../components/FJMainPreview/FJCreationEditPanel/js/FJViewCanvas';
import FJConfig from '../../config/FJConfig';
import FJS3Config from '../../config/FJS3Config';
import FJConstant from '../../constants/FJConstant';
import FJCompressedImageStore from '../../store/FJCompressedImageStore';
import FJImageStore from '../../store/FJImageStore';
import FJLocalStore from '../../store/FJLocalStore';
import FJMessageStore from '../../store/FJMessageStore';
import FJNetworkStore from '../../store/FJNetworkStore';
import FJPhotoBgRemoverStoreSingleton from '../../store/FJPhotoBgRemoverStore';
import FJUtil from '../../util/FJUtil';
import {
    setSliceAiMaskActive,
    setSliceBrushEditStatus,
    setSliceDisableReset,
    setSliceIsPhotoRemoveBg,
} from '../slices/FJSliceBrushEditCommon';
import { setSliceLoadingModalData, setSliceUpgradeTipsModalData } from '../slices/FJSliceModals';
import {
    DEFAULT_AUTO_EDIT_BG_IMAGE_DATA,
    DEFAULT_CUSTOM_EDIT_BG_IMAGE_DATA,
    setSliceAutoBgImageDataList,
    setSliceBackgroundPhotoList,
    setSliceBgApplyToAll,
    setSliceBgUsePhotoLoadingList,
    setSliceCurBgColor,
    setSliceCurMenuIndex,
    setSliceCurSelectAutoBgImageIndex,
    setSliceCurSelectBgData,
    setSliceCustomEditBgImageData,
    setSliceCustomUploadBgFileList,
    setSliceFlexClipBackgroundLoadStatus,
    setSliceStrokeApplyToAll,
    setSliceThumbnailList,
    USE_CREDIT,
} from '../slices/FJSlicePhotoBgRemover';
import FJActionBrushEditCommon from './FJActionBrushEditCommon';
import FJActionCommon from './FJActionCommon';
import FJActionImageStroke from './FJActionImageStroke';
import FJActionModal from './FJActionModal';
import FJLoadLocalforageStore from '../../store/FJLoadLocalforageStore';
import { setSelectedDownloadList, setSliceBatchDownloadLoadingAction } from '../slices/FJSliceCommon.js';
import FJActionEditPage from './FJActionEditPage.js';

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

const MAX_FILE_NUM = 10;

let _debouncedSetStrokeType = null;
let _switchMenuLoading = null;

const _judgeFile = file => {
    // 判断文件大小
    if (file.size > MAX_FILE_SIZE) {
        return {
            status: false,
            errorType: 'max-file',
        };
    }
    // 判断文件类型
    const isImage = file.type.startsWith('image/') && file.type !== 'image/gif';
    if (!isImage) {
        if (window.isEditPage) {
            if (file.type !== 'application/octet-stream' && file.type !== 'binary/octet-stream')
                return {
                    status: false,
                    errorType: 'unsupported-format',
                };
        } else
            return {
                status: false,
                errorType: 'unsupported-format',
            };
    }

    return {
        status: true,
    };
};

const _showTipByErrorType = errorType => {
    switch (errorType) {
        case 'max-file':
            FJMessageStore.addMessage(FJLocalStore._('the-max-image-size-is-xxx-mb').replace('xxx', 10), 'error');
            break;
        case 'unsupported-format':
            FJMessageStore.addMessage(
                FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                'error',
            );
            break;
    }
};

/**
 * @desc 自动去背景请求
 * @param {Object} autoEditBgImageData
 * @param {number} index
 * @param {Function} errorCallback
 * @param {Function} successCallback
 * @returns
 */
const _request = async function (autoEditBgImageData, index, errorCallback, successCallback) {
    try {
        const { data, code } = await FJNetworkStore.autoBackgroundRemove({
            image: autoEditBgImageData.originImgUrl,
        });

        if (code !== 200) {
            errorCallback && errorCallback(autoEditBgImageData, index);
            return;
        }

        const _data = await FJUtil.parseList([data]);
        if (_data.length === 0) {
            errorCallback && errorCallback(autoEditBgImageData, index);
            return;
        }

        const imgUrl = _data[0].imgUrl;

        const maskData = await FJPhotoBgRemoverStoreSingleton.imageToMaskData(imgUrl);

        if (!maskData) {
            errorCallback && errorCallback(autoEditBgImageData, index);
            return;
        }

        const maskDataKey = await FJPhotoBgRemoverStoreSingleton.saveAutoMaskData(
            maskData,
            autoEditBgImageData.id,
            true,
        );

        if (!maskDataKey) {
            errorCallback && errorCallback(autoEditBgImageData, index);
            return;
        }

        const newAutoBgImageData = {
            ...autoEditBgImageData,
            maskKey: maskDataKey,
            resetMaskKey: maskDataKey,
            isSelected: true,
            taskStatus: FJConstant.DEFAULT,
        };

        successCallback && successCallback(newAutoBgImageData, index);
    } catch (error) {
        errorCallback && errorCallback(autoEditBgImageData, index);
    }
};

const FJActionPhotoBgRemover = {
    resetAction: function () {
        return (dispatch, getState) => {
            dispatch(setSliceCustomEditBgImageData(null));
            dispatch(FJActionCommon.setHeaderTabIndexAction(0));
            FJPhotoBgRemoverStoreSingleton.clearUndoRedo();

            // 自动去背景
            dispatch(setSliceThumbnailList([]));
            dispatch(setSliceCurSelectAutoBgImageIndex(0));
            FJPhotoBgRemoverStoreSingleton.clearAutoLocalForage();
            dispatch(setSliceDisableReset(true));
            dispatch(setSliceAutoBgImageDataList([]));
            dispatch(setSliceIsPhotoRemoveBg(true));
            dispatch(FJActionBrushEditCommon.setCurBrushTypeAction(MOUSE_EVENT_TYPE.NONE));

            // 手动去背景
            FJPhotoBgRemoverStoreSingleton.clearCustomLocalForage();
            dispatch(setSliceAiMaskActive(true));
            dispatch(setSliceIsPhotoRemoveBg(false));

            dispatch(FJActionBrushEditCommon.endPhotoRemoveBgAction());

            dispatch(FJActionBrushEditCommon.setEditImageAction(null));
            dispatch(FJActionBrushEditCommon.setOriginImageAction(null));
        };
    },
    //#region 上传
    /**
     * @desc 上传自定义去背景图片
     * @param {File} file
     * @returns
     */
    uploadCustomBgImageFile: function (file) {
        return async (dispatch, getState) => {
            const customEditBgImageData = getState().photoBgRemover.customEditBgImageData;
            const isPhotoRemoveBg = getState().brushEditCommon.isPhotoRemoveBg;

            FJUtil.eaLog('ai tools page custom image bg remover next click');

            const __upload = async () => {
                const { status, errorType } = _judgeFile(file);
                if (!status) {
                    _showTipByErrorType(errorType);
                    return;
                }

                dispatch(FJActionCommon.setHeaderTabIndexAction(0));
                FJPhotoBgRemoverStoreSingleton.clearCustomLocalForage();
                dispatch(setSliceAiMaskActive(true));
                dispatch(setSliceIsPhotoRemoveBg(false));
                dispatch(
                    FJActionBrushEditCommon.setEditImageAction({
                        src: '',
                        isLoading: true,
                    }),
                );

                const data = await FJCompressedImageStore.compressImageByFile(file);
                const imageInfo = {
                    src: data.src,
                    width: data.width,
                    height: data.height,
                };
                dispatch(
                    setSliceCustomEditBgImageData({
                        ...DEFAULT_CUSTOM_EDIT_BG_IMAGE_DATA,
                        originImgUrl: data.src,
                    }),
                );
                dispatch(FJActionBrushEditCommon.endPhotoRemoveBgAction());
                dispatch(FJActionBrushEditCommon.setEditImageAction(imageInfo));
                dispatch(FJActionBrushEditCommon.setOriginImageAction(imageInfo));
            };

            const { hasUndo, hasRedo } = dispatch(this.getUndoRedoAction());
            if (customEditBgImageData && (hasUndo || hasRedo) && isPhotoRemoveBg) {
                dispatch(this._openMessageModel(() => {}, __upload));
                return;
            }

            __upload();
        };
    },

    /**
     * @desc 上传自动去背景图片
     * @param {File[]} files
     * @returns
     */
    uploadAutoBgImageFile: function (files) {
        return async (dispatch, getState) => {
            // const isImage = files && files.type.startsWith('image/') && files.type !== 'image/gif';
            let errorFileList = [];
            const filesToProcess = [...files];
            const isLocalhost = FJUtil.isLocalhost();
            const allRequestNum = filesToProcess.length;
            let requestFinishNum = 0;
            let isFree = false;

            FJUtil.eaLog('ai tools page auto image bg remover upload', { 'number of image': allRequestNum });

            const autoBgImageDataList = getState().photoBgRemover.autoBgImageDataList;
            const { hasUndo, hasRedo } = dispatch(this.getUndoRedoAction());
            if (autoBgImageDataList && autoBgImageDataList.length > 0 && (hasUndo || hasRedo)) {
                const isConfirm = await new Promise(resolve => {
                    dispatch(
                        this._openMessageModel(
                            () => {
                                resolve(false);
                            },
                            () => {
                                resolve(true);
                            },
                        ),
                    );
                });
                if (!isConfirm) {
                    return;
                }
            }

            // 本地调试使用
            let newAutoBgImageDataList = [
                {
                    originImgUrl: '',
                    taskStatus: FJConstant.START,
                },
            ];
            let requestNum = 0;

            // 统计
            const __successEaLog = () => {
                FJUtil.eaLog('ai tools page image bg remover success', {
                    type: 'auto',
                    'number of image': allRequestNum,
                    'credit&free': isFree ? 'free' : 'credit',
                });

                FJUtil.eaLog('ai tool generate success', {
                    'credit&free': isFree ? 'free' : 'credit',
                    tool: FJUtil.getToolName(),
                });
            };

            const __errorCallback = (autoEditBgImageData, index) => {
                FJMessageStore.addMessage(FJLocalStore._('unknown-error-please-try-again'), 'error');
                requestFinishNum++;
                dispatch(this._autoRequestErrorCallback(autoEditBgImageData, index));

                if (requestFinishNum === allRequestNum) {
                    dispatch(FJActionCommon.updateUserInfoAction());
                    FJUtil.updateLoginCreditNumber();
                    __successEaLog;
                }
            };

            const __successCallback = (newAutoBgImageData, index) => {
                dispatch(this._autoRequestSuccessCallback(newAutoBgImageData, index));
                requestFinishNum++;

                if (requestFinishNum === allRequestNum) {
                    dispatch(FJActionCommon.updateUserInfoAction());
                    FJUtil.updateLoginCreditNumber();
                    __successEaLog();
                }
            };

            const __addImageRemoveRequest = autoEditBgImageData => {
                const index = requestNum;

                dispatch(this._updateAutoBgImageReducerData(autoEditBgImageData, index));
                requestNum++;

                if (index === 0) {
                    dispatch(this._updateEditCanvas(autoEditBgImageData, index));
                }

                if (isLocalhost) {
                    const newAutoBgImageData = {
                        ...autoEditBgImageData,
                        taskStatus: FJConstant.DEFAULT,
                        isSelected: true,
                    };
                    if (index === 0) {
                        newAutoBgImageDataList[0] = newAutoBgImageData;
                    } else {
                        newAutoBgImageDataList.push(newAutoBgImageData);
                    }

                    dispatch(setSliceAutoBgImageDataList(FJUtil.deepClone(newAutoBgImageDataList)));
                    dispatch(this._updateEditCanvas(newAutoBgImageData, index));
                } else {
                    _request(autoEditBgImageData, index, __errorCallback, __successCallback);
                }
            };

            const __judgeCanGenerate = async () => {
                // 登录判断

                const userSpaceType = await FJUtil.checkUserSpace({
                    errorCallback: () => {
                        FJMessageStore.addMessage(FJLocalStore._('failed-to-remove-please-try-again'), 'error');
                    },
                });
                if (userSpaceType > 0) {
                    dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                    return;
                }

                // 额度判断
                const { creditNumber } = getState().common;
                const { autoBackgroundRemoveFreeNum } = getState().photoBgRemover;
                const canCredit = creditNumber >= filesToProcess.length * USE_CREDIT;
                const useFree = !canCredit && autoBackgroundRemoveFreeNum > 0;

                // 使用免费额度的情况下，最多只能上传一张图片
                if (useFree && filesToProcess.length > 1 && creditNumber === 0) {
                    // 免费不支持批量弹窗
                    dispatch(setSliceUpgradeTipsModalData({ display: true }));
                    return;
                }

                if (!canCredit && (!useFree || filesToProcess.length > 1)) {
                    // 弹出升级弹窗
                    !isLocalhost && dispatch(FJActionModal.showUpgradeModalAction());
                    return;
                }

                // 最多上传10张图片
                const uploadNum = filesToProcess.length;
                if (uploadNum > MAX_FILE_NUM) {
                    FJMessageStore.addMessage(
                        FJLocalStore._('you-can-remove-backgrounds-up-to-XXX-images-at-once').replace(
                            'XXX',
                            MAX_FILE_NUM,
                        ),
                        'error',
                    );
                    return;
                }

                isFree = useFree;
                return true;
            };

            const canGenerate = await __judgeCanGenerate();
            if (!canGenerate && !isLocalhost) {
                return;
            }

            for (let i = 0; i < filesToProcess.length; i++) {
                const file = filesToProcess[i];

                const { status, errorType } = _judgeFile(file);
                if (!status) {
                    _showTipByErrorType(errorType);
                    errorFileList.push({
                        file,
                        errorType,
                    });
                    requestFinishNum++;
                    continue;
                }

                const data = await FJCompressedImageStore.compressImageByFile(file);

                let autoEditBgImageData = {
                    ...DEFAULT_AUTO_EDIT_BG_IMAGE_DATA,
                    id: Math.random().toString(36).substring(2, 15),
                    name: file.name,
                    width: data.width,
                    height: data.height,
                    originImgUrl: '',
                    taskStatus: FJConstant.START,
                };

                // 画布进入加载状态
                if (i === 0) {
                    dispatch(setSliceThumbnailList([]));
                    dispatch(setSliceCurSelectAutoBgImageIndex(0));
                    FJPhotoBgRemoverStoreSingleton.clearAutoLocalForage();
                    FJPhotoBgRemoverStoreSingleton.clearUndoRedo();
                    dispatch(setSliceDisableReset(true));
                    dispatch(setSliceAutoBgImageDataList([{ ...autoEditBgImageData }]));
                    dispatch(setSliceIsPhotoRemoveBg(true));
                    dispatch(FJActionBrushEditCommon.setCurBrushTypeAction(MOUSE_EVENT_TYPE.NONE));
                    dispatch(
                        FJActionBrushEditCommon.setEditImageAction({ src: '', width: data.width, height: data.height }),
                    );
                    dispatch(setSliceBrushEditStatus(FJConstant.START));

                    const tool = FJUtil.getToolName();
                    FJUtil.eaLog('ai tool start generating', {
                        'credit&free': isFree ? 'free' : 'credit',
                        tool,
                    });
                }

                try {
                    let s3Url = [];
                    if (isLocalhost) {
                        s3Url = [data.src];
                    } else {
                        s3Url = await FJImageStore.uploadFilesByUrl([data.src]);
                    }

                    if (s3Url.length === 0 || !s3Url[0] || s3Url[0] === '') {
                        throw new Error('upload failed');
                    }

                    autoEditBgImageData.originImgUrl = s3Url[0];
                    __addImageRemoveRequest(autoEditBgImageData);
                } catch (error) {
                    requestFinishNum++;
                    __errorCallback({ ...autoEditBgImageData, originImgUrl: data.src }, i);
                    continue;
                }
            }
        };
    },

    //#endregion

    checkLimitWithPhotoBgRemoveAction: function (files, callback) {
        return (dispatch, getState) => {
            // 额度判断
            const { creditNumber } = getState().common;
            const { autoBackgroundRemoveFreeNum } = getState().photoBgRemover;
            const canCredit = creditNumber >= files.length * USE_CREDIT;
            const useFree = !canCredit && autoBackgroundRemoveFreeNum > 0;
            const isLocalhost = FJUtil.isLocalhost();

            if (files.length > MAX_FILE_NUM) {
                FJMessageStore.addMessage(
                    FJLocalStore._('you-can-remove-backgrounds-up-to-XXX-images-at-once').replace('XXX', MAX_FILE_NUM),
                    'error',
                );
                callback && callback(false);
                return;
            }

            // 使用免费额度的情况下，最多只能上传一张图片
            if (useFree && files.length > 1 && creditNumber === 0) {
                // 免费不支持批量弹窗
                dispatch(setSliceUpgradeTipsModalData({ display: true }));
                callback && callback(false);
                return;
            }

            if (!canCredit && (!useFree || files.length > 1)) {
                // 弹出升级弹窗
                !isLocalhost && dispatch(FJActionModal.showUpgradeModalAction());
                callback && callback(false);
                return;
            }

            callback && callback(true);
        };
    },

    /**
     * @desc 根据核心数据更新界面数据
     * @returns
     */
    updateDataByFJViewCanvas: function () {
        return async (dispatch, getState) => {
            const isPhotoRemoveBg = FJViewCanvasSingleton.isPhotoRemoveBg;
            if (!isPhotoRemoveBg) {
                return;
            }

            const isAutoBg = getState().photoBgRemover.curMenuIndex === 0;
            if (isAutoBg) {
                const { hasUndo, hasRedo } = dispatch(this.getUndoRedoAction());
                dispatch(setSliceDisableReset(!hasUndo && !hasRedo));
            }

            const strokeInfo = FJViewCanvasSingleton.getStrokeInfo();
            if (strokeInfo) {
                dispatch(FJActionImageStroke.onStrokeChangeAction(strokeInfo));
            } else {
                dispatch(FJActionImageStroke.onStrokeChangeAction({ type: 'none' }));
            }

            const backgroundInfo = FJViewCanvasSingleton.getBackgroundInfo();
            const { backgroundType, backgroundImage, backgroundColor } = backgroundInfo;

            if (backgroundType === BACKGROUND_TYPE.IMAGE) {
                dispatch(
                    setSliceCurSelectBgData({
                        key: backgroundImage.key,
                        url: backgroundImage.url,
                        isAiPhoto: backgroundImage.isAiPhoto,
                    }),
                );
                dispatch(setSliceCurBgColor(''));
            } else if (backgroundType === BACKGROUND_TYPE.COLOR) {
                dispatch(setSliceCurBgColor(backgroundColor));
                dispatch(setSliceCurSelectBgData(null));
            } else {
                dispatch(setSliceCurBgColor(''));
                dispatch(setSliceCurSelectBgData(null));
            }
        };
    },

    /**
     * @desc 更新创建编辑数据
     * @returns
     */
    updateCreationEditDataAction: function () {
        return async (dispatch, getState) => {
            const curMenuIndex = getState().photoBgRemover.curMenuIndex;
            if (curMenuIndex === 1) {
                const customEditBgImageData = getState().photoBgRemover.customEditBgImageData;
                if (customEditBgImageData) {
                    const isPhotoRemoveBg = customEditBgImageData.isPhotoRemoveBg;
                    if (!isPhotoRemoveBg) {
                        const __successCallback = () => {
                            dispatch(this._updateCustomEditBgImageData());
                        };
                        dispatch(FJActionBrushEditCommon.initAiMaskCanvas(__successCallback));
                    } else {
                        dispatch(this._updateCustomEditBgImageData());
                    }
                }
            } else {
                dispatch(this._updateAutoEditBgImageData());
            }
        };
    },

    /**
     * @desc 保存自定义去背景图片数据
     * @returns
     */
    _saveCustomEditBgImageData: function (isRestMask = false) {
        return async (dispatch, getState) => {
            const customEditBgImageData = getState().photoBgRemover.customEditBgImageData;
            if (!customEditBgImageData) {
                return;
            }

            const undoAndRedoData = FJCreationEditUndoRedoManager.getUndoAndRedoData();
            const maskData = FJViewCanvasSingleton.getMaskData(FJViewCanvasSingleton.isPhotoRemoveBg);

            const maskKey = await FJPhotoBgRemoverStoreSingleton.saveCustomMaskData(
                maskData,
                customEditBgImageData.maskKey,
                isRestMask,
            );

            const aiMaskUndoRedoData = FJViewCanvasSingleton.getAiMaskUndoRedoData();
            const backgroundInfo = FJViewCanvasSingleton.getBackgroundInfo();
            const strokeData = FJViewCanvasSingleton.getStrokeInfo();
            const bgData = FJViewCanvasSingleton.getBackgroundInfo();
            const isPhotoRemoveBg = FJViewCanvasSingleton.isPhotoRemoveBg;

            if (isRestMask) {
                dispatch(
                    setSliceCustomEditBgImageData({
                        ...customEditBgImageData,
                        undoAndRedoData,
                        maskKey,
                        aiMaskData: aiMaskUndoRedoData,
                        backgroundInfo,
                        isPhotoRemoveBg,
                        strokeData,
                        bgData,
                        resetMaskKey: maskKey,
                    }),
                );
            } else {
                dispatch(
                    setSliceCustomEditBgImageData({
                        ...customEditBgImageData,
                        undoAndRedoData,
                        maskKey,
                        aiMaskData: aiMaskUndoRedoData,
                        backgroundInfo,
                        isPhotoRemoveBg,
                        strokeData,
                        bgData,
                    }),
                );
            }
        };
    },

    /**
     * @desc 更新自定义去背景图片数据 按数据更新界面
     * @param {Object} customEditBgImageData
     * @returns
     */
    _updateCustomEditBgImageData: function () {
        return async (dispatch, getState) => {
            const customEditBgImageData = getState().photoBgRemover.customEditBgImageData;

            if (!customEditBgImageData) {
                dispatch(setSliceBrushEditStatus(FJConstant.DEFAULT));
                return;
            }

            const { maskKey, aiMaskData, undoAndRedoData, isPhotoRemoveBg, taskStatus, bgData, strokeData } =
                customEditBgImageData;

            if (isPhotoRemoveBg) {
                await dispatch(FJActionBrushEditCommon.enterPhotoRemoveBgAction());
            }

            dispatch(setSliceBrushEditStatus(taskStatus));
            const maskData = await FJPhotoBgRemoverStoreSingleton.getCustomLocalForageItem(maskKey);
            FJViewCanvasSingleton.setMaskData(maskData);

            FJViewCanvasSingleton.setAiMaskUndoRedoData(aiMaskData);
            FJViewCanvasSingleton.setStrokeInfo(strokeData, true);
            await FJViewCanvasSingleton.setBackgroundInfo(bgData);
            undoAndRedoData && FJCreationEditUndoRedoManager.setUndoAndRedoData(undoAndRedoData);
            FJViewCanvasSingleton.updateView();
            FJViewCanvasSingleton.draw();

            if (undoAndRedoData && undoAndRedoData.undoStack.length > 0) {
                dispatch(setSliceDisableReset(false));
            }

            dispatch(FJActionBrushEditCommon.updateBrushUndoRedoAction());
            dispatch(FJActionBrushEditCommon.updateDisableCompareAction());
            dispatch(this.updateDataByFJViewCanvas());
        };
    },

    /**
     * @desc 更新自动去背景图片数据  按界面更新数据
     * @param {Object} newData
     * @param {string} changeType
     * @returns
     */
    _saveAutoBgImageData: function (newData, changeType, isAddUndo = true, isReset = false) {
        return async (dispatch, getState) => {
            const autoBgImageDataList = getState().photoBgRemover.autoBgImageDataList;
            const curSelectAutoBgImageIndex = getState().photoBgRemover.curSelectAutoBgImageIndex;
            const autoBgImageData = autoBgImageDataList[curSelectAutoBgImageIndex];

            if (isAddUndo) {
                await dispatch(this.addUndoAction());
            }
            const updatedAutoBgImageDataList = FJUtil.deepClone(autoBgImageDataList);

            switch (changeType) {
                case 'bgData': {
                    const bgApplyToAll = getState().photoBgRemover.bgApplyToAll;
                    if (bgApplyToAll && !isReset) {
                        updatedAutoBgImageDataList.forEach(item => {
                            item.bgData = newData;
                        });
                    } else {
                        updatedAutoBgImageDataList[curSelectAutoBgImageIndex] = {
                            ...autoBgImageData,
                            bgData: newData,
                        };
                    }
                    break;
                }

                case 'strokeData': {
                    const strokeApplyToAll = getState().photoBgRemover.strokeApplyToAll;
                    if (strokeApplyToAll && !isReset) {
                        updatedAutoBgImageDataList.forEach(item => {
                            item.strokeData = newData;
                        });
                    } else {
                        updatedAutoBgImageDataList[curSelectAutoBgImageIndex] = {
                            ...autoBgImageData,
                            strokeData: newData,
                        };
                    }
                    break;
                }

                case 'maskData': {
                    const maskKey = await FJPhotoBgRemoverStoreSingleton.saveAutoMaskData(
                        newData,
                        autoBgImageData.maskKey,
                    );
                    updatedAutoBgImageDataList[curSelectAutoBgImageIndex] = {
                        ...autoBgImageData,
                        maskKey: maskKey,
                    };
                    break;
                }

                case 'maskKey': {
                    updatedAutoBgImageDataList[curSelectAutoBgImageIndex] = {
                        ...autoBgImageData,
                        maskKey: newData,
                    };
                    break;
                }

                default: {
                    updatedAutoBgImageDataList[curSelectAutoBgImageIndex] = {
                        ...autoBgImageData,
                        [changeType]: newData,
                    };
                    break;
                }
            }

            dispatch(setSliceAutoBgImageDataList(updatedAutoBgImageDataList));
        };
    },

    /**
     * @desc 更新自动去背景图片数据  按数据更新界面
     * @returns
     */
    _updateAutoEditBgImageData: function () {
        return async (dispatch, getState) => {
            const autoBgImageDataList = getState().photoBgRemover.autoBgImageDataList;
            if (!autoBgImageDataList || autoBgImageDataList.length === 0) {
                return;
            }

            const curSelectAutoBgImageIndex = getState().photoBgRemover.curSelectAutoBgImageIndex;
            const autoBgImageData = autoBgImageDataList[curSelectAutoBgImageIndex];

            if (!autoBgImageData) {
                dispatch(setSliceBrushEditStatus(FJConstant.DEFAULT));
                return;
            }

            await dispatch(FJActionBrushEditCommon.enterPhotoRemoveBgAction());

            const { maskKey, bgData, strokeData, taskStatus } = autoBgImageData;

            if (maskKey) {
                const maskData = await FJPhotoBgRemoverStoreSingleton.getAutoLocalForageItem(maskKey);
                FJViewCanvasSingleton.setMaskData(maskData);
            } else {
                FJViewCanvasSingleton.setMaskData(null);
            }

            dispatch(setSliceBrushEditStatus(taskStatus));
            await FJViewCanvasSingleton.setBackgroundInfo(bgData);
            FJViewCanvasSingleton.setStrokeInfo(strokeData, true);

            FJViewCanvasSingleton.updateView();
            FJViewCanvasSingleton.draw();

            dispatch(FJActionBrushEditCommon.updateBrushUndoRedoAction());
            dispatch(FJActionBrushEditCommon.updateDisableCompareAction());
            dispatch(this.updateDataByFJViewCanvas());
        };
    },

    //#region 自定义去背景 下一步

    /**
     * @desc 自定义去背景下一步
     * @returns
     */
    customNextStepAction: function () {
        return async (dispatch, getState) => {
            dispatch(FJActionCommon.setHeaderTabIndexAction(0));
            dispatch(setSliceLoadingModalData({ display: true, message: `${FJLocalStore._('recognizing...')}` }));
            let isFree = false;

            const __judgeCanGenerate = async () => {
                const { creditNumber } = getState().common;
                const { backgroundRemoveFreeNum } = getState().photoBgRemover;

                const userSpaceType = await FJUtil.checkUserSpace({
                    errorCallback: () => {
                        FJMessageStore.addMessage(FJLocalStore._('failed-to-remove-please-try-again'), 'error');
                    },
                });
                if (userSpaceType > 0) {
                    dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                    return false;
                }
                //免费判断
                const canFreeCreate = backgroundRemoveFreeNum > 0;

                if (creditNumber < USE_CREDIT && !canFreeCreate) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    return false;
                }

                isFree = canFreeCreate && creditNumber < USE_CREDIT;
                return true;
            };

            // 成功统计
            const __successEaLog = () => {
                FJUtil.eaLog('ai tools page image bg remover success', {
                    type: 'custom',
                    'credit&free': isFree ? 'free' : 'credit',
                });

                FJUtil.eaLog('ai tool generate success', {
                    'credit&free': isFree ? 'free' : 'credit',
                    tool: FJUtil.getToolName(),
                });
            };

            try {
                const canGenerate = await __judgeCanGenerate();
                if (!canGenerate) {
                    return;
                }

                const originBlob = await FJViewCanvasSingleton.getEditImageBlob();
                const editBlob = await FJViewCanvasSingleton.getRemoveBgImageBlob();

                if (!originBlob || !editBlob) {
                    return;
                }

                const __getFileName = async s3Url => {
                    const url = new URL(s3Url);
                    const key = url.pathname.split('/').pop();
                    return key;
                };

                const originImageUrl = await FJImageStore.uploadFileByBlob(originBlob);
                const editImageUrl = await FJImageStore.uploadFileByBlob(editBlob, true);

                if (originImageUrl && editImageUrl) {
                    const size = FJViewCanvasSingleton.getEditImageSize();

                    const tool = FJUtil.getToolName();
                    FJUtil.eaLog('ai tool start generating', {
                        'credit&free': isFree ? 'free' : 'credit',
                        tool,
                    });
                    const result = await FJNetworkStore.createRemoveBackgroundHistory({
                        filename: await __getFileName(editImageUrl),
                        original: await __getFileName(originImageUrl),
                        info: {
                            width: size.width,
                            height: size.height,
                            isCustomRemoveBg: true,
                        },
                    });

                    if (result.code === 200) {
                        dispatch(setSliceDisableReset(true));
                        await dispatch(FJActionBrushEditCommon.enterPhotoRemoveBgAction());
                        dispatch(this._saveCustomEditBgImageData(true));
                        dispatch(this.updateDataByFJViewCanvas());
                        dispatch(FJActionCommon.updateUserInfoAction());
                        FJUtil.updateLoginCreditNumber();

                        __successEaLog();
                    } else {
                        throw new Error();
                    }
                }
            } catch (error) {
                FJMessageStore.addMessage(FJLocalStore._('failed-to-remove-please-try-again'), 'error');
            } finally {
                dispatch(setSliceLoadingModalData({ display: false }));
            }
        };
    },

    /**
     * @desc 生成
     * @returns
     */
    generateAction: function () {
        return async (dispatch, getState) => {
            const curMenuIndex = getState().photoBgRemover.curMenuIndex;
            if (curMenuIndex === 1) {
                dispatch(this.customNextStepAction());
            }
        };
    },
    //#endregion

    //#region 用到所有图片
    /**
     * @desc 设置是否应用到所有图片
     * @param {boolean} value
     * @returns
     */
    bgApplyToAllAction: function (value) {
        return async (dispatch, getState) => {
            const isAutoBg = getState().photoBgRemover.curMenuIndex === 0;
            if (isAutoBg) {
                await dispatch(this._savaAndExitBrushEdit());
                dispatch(setSliceBgApplyToAll(value));

                const bgData = FJViewCanvasSingleton.getBackgroundInfo();
                if (bgData) {
                    setTimeout(() => {
                        dispatch(this._saveAutoBgImageData(bgData, 'bgData'));
                    }, 100);
                } else {
                    dispatch(this._saveCustomEditBgImageData());
                }
            }
        };
    },

    /**
     * @desc 设置是否应用到所有图片
     * @param {boolean} value
     * @returns
     */
    strokeApplyToAllAction: function (value) {
        return async (dispatch, getState) => {
            const isAutoBg = getState().photoBgRemover.curMenuIndex === 0;
            if (isAutoBg) {
                await dispatch(this._savaAndExitBrushEdit());
                dispatch(setSliceStrokeApplyToAll(value));

                const strokeInfo = FJViewCanvasSingleton.getStrokeInfo();
                if (strokeInfo) {
                    setTimeout(() => {
                        dispatch(this._saveAutoBgImageData(strokeInfo, 'strokeData'));
                    }, 100);
                }
            } else {
                dispatch(this._saveCustomEditBgImageData());
            }
        };
    },

    //#endregion

    //#region 背景图片使用中列表
    /**
     * @desc 添加背景图片使用中列表
     * @param {Object} item
     * @returns
     */
    addBgUsePhotoLoadingList: function (item) {
        return async (dispatch, getState) => {
            dispatch(setSliceBgUsePhotoLoadingList([...getState().photoBgRemover.bgUsePhotoLoadingList, item]));
        };
    },

    /**
     * @desc 移除背景图片使用中列表
     * @param {Object} item
     * @returns
     */
    removeBgUsePhotoLoadingList: function (item) {
        return async (dispatch, getState) => {
            dispatch(
                setSliceBgUsePhotoLoadingList(
                    getState().photoBgRemover.bgUsePhotoLoadingList.filter(i => i.id !== item.id),
                ),
            );
        };
    },
    //#endregion

    //#region 去背景属性修改
    /**
     * @desc 设置背景图片
     * @param {Object} item
     * @returns
     */
    setBackgroundImageAction: function (item = {}, isAiPhoto = false) {
        return async (dispatch, getState) => {
            await dispatch(this._savaAndExitBrushEdit());
            const { url } = item;

            if (!url) return;

            const downloadUrl =
                !isAiPhoto && !item.isCustomUpload
                    ? FJConfig.serverPath + FJConfig.flexClipBgPhotoBaseUrl + item.name
                    : url;

            const key = isAiPhoto || item.isCustomUpload ? item.id : item.name;
            const backgroundInfo = {
                url: downloadUrl,
                isAiPhoto: isAiPhoto,
                key,
            };
            dispatch(this.addBgUsePhotoLoadingList(backgroundInfo));
            const isSuccess = await dispatch(FJActionBrushEditCommon.setBackgroundImageAction(backgroundInfo));
            dispatch(this.removeBgUsePhotoLoadingList(backgroundInfo));
            if (!isSuccess) {
                FJMessageStore.addMessage(FJLocalStore._('failed-to-load-image-please-try-again'), 'error');
                return;
            }

            dispatch(
                setSliceCurSelectBgData({
                    key,
                    url: downloadUrl,
                    isAiPhoto: isAiPhoto,
                }),
            );
            dispatch(setSliceCurBgColor(''));
            dispatch(setSliceDisableReset(false));

            const isAutoBg = getState().photoBgRemover.curMenuIndex === 0;
            if (isAutoBg) {
                const bgData = {
                    backgroundType: BACKGROUND_TYPE.IMAGE,
                    backgroundImage: backgroundInfo,
                    backgroundColor: '',
                };
                dispatch(this._saveAutoBgImageData(bgData, 'bgData'));
            } else {
                dispatch(this._saveCustomEditBgImageData());
            }
        };
    },

    /**
     * @desc 设置背景颜色
     * @param {string} color
     * @returns
     */
    setBackgroundColorAction: function (color, changeType = FJConstant.CHANGE_END) {
        return async (dispatch, getState) => {
            await dispatch(this._savaAndExitBrushEdit());
            dispatch(FJActionBrushEditCommon.setBackgroundColorAction(color, changeType));
            dispatch(setSliceCurBgColor(color));
            dispatch(setSliceCurSelectBgData(null));

            const isAutoBg = getState().photoBgRemover.curMenuIndex === 0;

            const isAddUndo = changeType === FJConstant.CLICK || changeType === FJConstant.CHANGE_START;
            if (
                changeType === FJConstant.CLICK ||
                changeType === FJConstant.CHANGE_END ||
                changeType === FJConstant.CHANGE_START
            ) {
                if (isAutoBg) {
                    const bgData = {
                        backgroundType: BACKGROUND_TYPE.COLOR,
                        backgroundColor: color,
                        backgroundImage: '',
                    };
                    dispatch(this._saveAutoBgImageData(bgData, 'bgData', isAddUndo));
                } else {
                    dispatch(this._saveCustomEditBgImageData());
                }
            }
        };
    },

    /**
     * @desc 设置描边信息
     * @param {Object} data
     * @param {Object} data.strokeInfo
     * @param {string} changeType
     * @returns
     */
    setStrokeInfoAction: function (data, changeType = FJConstant.CHANGE_END, isStrokeTypeChange = false) {
        return async (dispatch, getState) => {
            await dispatch(this._savaAndExitBrushEdit());
            dispatch(FJActionBrushEditCommon.setStrokeInfoAction(data, changeType, isStrokeTypeChange));

            const isAutoBg = getState().photoBgRemover.curMenuIndex === 0;

            if (changeType === FJConstant.CHANGE_END || isStrokeTypeChange) {
                const { strokeInfo } = data;
                if (isAutoBg) {
                    dispatch(this._saveAutoBgImageData(strokeInfo, 'strokeData'));
                } else {
                    // 存在延迟设置优化 这里设置延迟 保证存储的数据正确
                    if (!_debouncedSetStrokeType) {
                        _debouncedSetStrokeType = _.debounce(
                            () => {
                                dispatch(this._saveCustomEditBgImageData());
                            },
                            200,
                            { trailing: true },
                        );
                    }
                    _debouncedSetStrokeType();
                }
                dispatch(setSliceDisableReset(false));
            }
        };
    },

    /**
     * @desc 应用去背景画笔
     * @returns
     */
    applyPhotoRemoveBgBrushAction: function () {
        return async (dispatch, getState) => {
            const isAutoBg = getState().photoBgRemover.curMenuIndex === 0;
            if (isAutoBg) {
                const maskData = FJViewCanvasSingleton.getMaskData(true);
                dispatch(this._saveAutoBgImageData(maskData, 'maskData'));
            } else {
                dispatch(this._saveCustomEditBgImageData());
            }
        };
    },

    /**
     * @desc 取消去背景画笔
     * @returns
     */
    cancelPhotoRemoveBgBrushAction: function () {
        return async () => {
            // dispatch(FJActionBrushEditCommon.cancelPhotoRemoveBgBrushAction());
        };
    },

    /**
     * @desc 移除背景
     * @returns
     */
    removeBgAction: function () {
        return (dispatch, getState) => {
            const isUpdateBg = dispatch(FJActionBrushEditCommon.resetBackgroundAction());
            if (!isUpdateBg) return;

            dispatch(setSliceCurBgColor(''));
            dispatch(setSliceCurSelectBgData(null));

            const isAutoBg = getState().photoBgRemover.curMenuIndex === 0;
            if (isAutoBg) {
                dispatch(
                    this._saveAutoBgImageData(
                        {
                            backgroundType: BACKGROUND_TYPE.TRANSPARENT,
                            backgroundImage: null,
                            backgroundColor: null,
                        },
                        'bgData',
                    ),
                );
            } else {
                dispatch(this._saveCustomEditBgImageData());
            }
        };
    },
    //#endregion

    //#region 自动去背景独有

    /**
     * @desc 更新自动去背景图片 reducer 数据列表
     * @param {Object} newAutoBgImageData
     * @param {number} index
     * @returns
     */
    _updateAutoBgImageReducerData: function (newAutoBgImageData, index) {
        return async (dispatch, getState) => {
            const autoBgImageDataList = getState().photoBgRemover.autoBgImageDataList;
            const newAutoBgImageDataList = [...autoBgImageDataList];
            newAutoBgImageDataList[index] = newAutoBgImageData;
            dispatch(setSliceAutoBgImageDataList(newAutoBgImageDataList));
        };
    },

    /**
     * @desc 切换自动去背景当前编辑图片
     * @param {number} index
     * @returns
     */
    changeCurSelectAutoBgImage: function (index) {
        return async (dispatch, getState) => {
            const curSelectAutoBgImageIndex = getState().photoBgRemover.curSelectAutoBgImageIndex;
            const autoBgImageDataList = getState().photoBgRemover.autoBgImageDataList;
            const autoBgImageInfo = autoBgImageDataList[index];

            if (curSelectAutoBgImageIndex !== index) {
                // 检查是否处于去背景的画笔状态
                await dispatch(this._savaAndExitBrushEdit());
                dispatch(setSliceCurSelectAutoBgImageIndex(index));
            }

            if (autoBgImageInfo.taskStatus === FJConstant.ERROR) {
                dispatch(this.retryAction());
            } else {
                dispatch(
                    FJActionBrushEditCommon.setEditImageAction({
                        src: autoBgImageInfo.taskStatus !== FJConstant.START ? autoBgImageInfo.originImgUrl : '',
                        width: autoBgImageInfo.width,
                        height: autoBgImageInfo.height,
                    }),
                );
            }
        };
    },

    /**
     * @desc 更新编辑画布
     * @param {Object} newAutoBgImageData
     * @param {number} index
     * @returns
     */
    _updateEditCanvas: function (newAutoBgImageData, index) {
        return async (dispatch, getState) => {
            const isAutoBg = getState().photoBgRemover.curMenuIndex === 0;
            if (!isAutoBg) return;

            const curSelectAutoBgImageIndex = getState().photoBgRemover.curSelectAutoBgImageIndex;
            if (curSelectAutoBgImageIndex !== index) {
                return;
            }

            dispatch(
                FJActionBrushEditCommon.setEditImageAction({
                    src: newAutoBgImageData.taskStatus !== FJConstant.START ? newAutoBgImageData.originImgUrl : '',
                    width: newAutoBgImageData.width,
                    height: newAutoBgImageData.height,
                }),
            );
        };
    },

    /**
     * @desc 自动去背景请求错误回调
     * @param {Object} autoEditBgImageData
     * @param {number} index
     * @returns
     */
    _autoRequestErrorCallback: function (autoEditBgImageData, index) {
        return async dispatch => {
            const newAutoBgImageData = {
                ...autoEditBgImageData,
                taskStatus: FJConstant.ERROR,
            };

            dispatch(this._updateAutoBgImageReducerData(newAutoBgImageData, index));
            dispatch(this._updateEditCanvas(newAutoBgImageData, index));
        };
    },

    /**
     * @desc 自动去背景请求成功回调
     * @param {Object} newAutoBgImageData
     * @param {number} index
     * @returns
     */
    _autoRequestSuccessCallback: function (newAutoBgImageData, index) {
        return async dispatch => {
            const autoBgImageData = {
                ...newAutoBgImageData,
                taskStatus: FJConstant.DEFAULT,
                isSelected: true,
            };

            dispatch(this._updateAutoBgImageReducerData(autoBgImageData, index));
            dispatch(this._updateEditCanvas(autoBgImageData, index));
        };
    },

    //#endregion

    //#region undo、redo

    /**
     * @desc 改变自动去背景的undo、redo数据
     * @param {Object} data
     * @returns
     */
    changeAutoUndoRedoData: function (data) {
        return async (dispatch, getState) => {
            const curSelectAutoBgImageIndex = getState().photoBgRemover.curSelectAutoBgImageIndex;
            const { dataList, curSelectIndex } = data;
            dispatch(setSliceAutoBgImageDataList(dataList));

            if (curSelectAutoBgImageIndex !== curSelectIndex) {
                dispatch(this.changeCurSelectAutoBgImage(curSelectIndex));
            } else {
                dispatch(this._updateAutoEditBgImageData());
            }
        };
    },
    /**
     * @desc 更新undo、redo状态
     * @returns
     */
    getUndoRedoAction: function () {
        return (dispatch, getState) => {
            const isAutoBg = getState().photoBgRemover.curMenuIndex === 0;
            const curBrushType = getState().brushEditCommon.curBrushType;

            if (isAutoBg && curBrushType === MOUSE_EVENT_TYPE.NONE) {
                const hasUndo = FJPhotoBgRemoverStoreSingleton.hasUndo();
                const hasRedo = FJPhotoBgRemoverStoreSingleton.hasRedo();

                return { hasUndo, hasRedo };
            } else {
                const hasUndo = FJCreationEditUndoRedoManager.hasUndo();
                const hasRedo = FJCreationEditUndoRedoManager.hasRedo();

                return { hasUndo, hasRedo };
            }
        };
    },

    /**
     * @desc 添加undo
     * @returns
     */
    addUndoAction(isRedo = false) {
        return async (dispatch, getState) => {
            const autoBgImageDataList = getState().photoBgRemover.autoBgImageDataList;
            const curSelectAutoBgImageIndex = getState().photoBgRemover.curSelectAutoBgImageIndex;

            FJPhotoBgRemoverStoreSingleton.addUndo(
                {
                    dataList: autoBgImageDataList,
                    curSelectIndex: curSelectAutoBgImageIndex,
                },
                isRedo,
            );

            dispatch(FJActionBrushEditCommon.updateBrushUndoRedoAction());
        };
    },

    /**
     * @desc 添加redo
     * @returns
     */
    addRedoAction() {
        return async (dispatch, getState) => {
            const autoBgImageDataList = getState().photoBgRemover.autoBgImageDataList;
            const curSelectAutoBgImageIndex = getState().photoBgRemover.curSelectAutoBgImageIndex;

            FJPhotoBgRemoverStoreSingleton.addRedo({
                dataList: autoBgImageDataList,
                curSelectIndex: curSelectAutoBgImageIndex,
            });

            dispatch(FJActionBrushEditCommon.updateBrushUndoRedoAction());
        };
    },

    /**
     * @desc undo
     * @returns
     */
    undoAction: function () {
        return async (dispatch, getState) => {
            const isAutoBg = getState().photoBgRemover.curMenuIndex === 0;
            const curBrushType = getState().brushEditCommon.curBrushType;
            if (isAutoBg && curBrushType === MOUSE_EVENT_TYPE.NONE) {
                // 全局undo、redo
                dispatch(this.addRedoAction());
                const undoData = FJPhotoBgRemoverStoreSingleton.undo();
                dispatch(this.changeAutoUndoRedoData(undoData));
                dispatch(setSliceDisableReset(false));
            } else if (!isAutoBg) {
                await FJViewCanvasSingleton.undo();
                dispatch(setSliceDisableReset(false));
                dispatch(FJActionBrushEditCommon.updateBrushUndoRedoAction());
                dispatch(this.updateDataByFJViewCanvas());
                dispatch(this._saveCustomEditBgImageData());
            } else {
                await FJViewCanvasSingleton.undo();
                dispatch(setSliceDisableReset(false));
                dispatch(FJActionBrushEditCommon.updateBrushUndoRedoAction());
            }
        };
    },

    /**
     * @desc redo
     * @returns
     */
    redoAction: function () {
        return async (dispatch, getState) => {
            const isAutoBg = getState().photoBgRemover.curMenuIndex === 0;
            const curBrushType = getState().brushEditCommon.curBrushType;
            if (isAutoBg && curBrushType === MOUSE_EVENT_TYPE.NONE) {
                // 全局undo、redo
                dispatch(this.addUndoAction(true));
                const redoData = FJPhotoBgRemoverStoreSingleton.redo();
                dispatch(this.changeAutoUndoRedoData(redoData));
                dispatch(setSliceDisableReset(false));
            } else if (!isAutoBg) {
                await FJViewCanvasSingleton.redo();
                dispatch(setSliceDisableReset(false));
                dispatch(FJActionBrushEditCommon.updateBrushUndoRedoAction());
                dispatch(this.updateDataByFJViewCanvas());
                dispatch(this._saveCustomEditBgImageData());
            } else {
                await FJViewCanvasSingleton.redo();
                dispatch(setSliceDisableReset(false));
                dispatch(FJActionBrushEditCommon.updateBrushUndoRedoAction());
            }
        };
    },

    //#endregion

    //#region 下载
    /**
     * @desc 下载列表点击
     * @param {Object} item
     * @returns
     */
    downloadListItemSelectAction: function (item) {
        return async (dispatch, getState) => {
            // 只有自动去背景有下载列表
            const curMenuIndex = getState().photoBgRemover.curMenuIndex;
            if (curMenuIndex !== 0) return;

            const thumbnailList = getState().photoBgRemover.thumbnailList;
            const newThumbnailList = FJUtil.deepClone(thumbnailList);

            const findIndex = newThumbnailList.findIndex(_item => _item.id === item.id);
            if (findIndex === -1) return;

            newThumbnailList[findIndex].isSelected = !newThumbnailList[findIndex].isSelected;

            dispatch(setSliceThumbnailList(newThumbnailList));
        };
    },

    /**
     * @desc 全选下载列表点击
     * @param {boolean} isSelected
     * @returns
     */
    allDownloadListClickAction: function (isSelected) {
        return async (dispatch, getState) => {
            const curMenuIndex = getState().photoBgRemover.curMenuIndex;
            if (curMenuIndex !== 0) return;

            const thumbnailList = getState().photoBgRemover.thumbnailList;
            const newThumbnailList = FJUtil.deepClone(thumbnailList);

            newThumbnailList.forEach(item => {
                item.isSelected = isSelected;
            });

            dispatch(setSliceThumbnailList(newThumbnailList));
        };
    },

    /**
     * @desc 下载点击
     * @param {Array} downloadList
     * @returns
     */
    downloadClickAction: function () {
        return async (dispatch, getState) => {
            const curMenuIndex = getState().photoBgRemover.curMenuIndex;

            let downloadList = [];
            // 自动去背景
            if (curMenuIndex === 0) {
                const thumbnailList = getState().photoBgRemover.thumbnailList;
                const autoBgImageDataList = getState().photoBgRemover.autoBgImageDataList;

                const selectIdList = thumbnailList.filter(item => item.isSelected).map(item => item.id);

                downloadList = autoBgImageDataList.filter(item => selectIdList.includes(item.id));
            } else {
                downloadList = [getState().photoBgRemover.customEditBgImageData];
            }

            FJUtil.eaLog('ai tool download click', {
                source: 'creation',
            });

            await FJPhotoBgRemoverStoreSingleton.downloadImageList(downloadList, curMenuIndex === 0);
        };
    },

    // 在编辑页中进行下载选中的,因为在编辑页中和ai工具页中的组件逻辑不一样，所以单独写一个方法
    downloadSelectedItemsAction: function () {
        return (dispatch, getState) => {
            const { curMenuIndex, autoBgImageDataList = [], customEditBgImageData } = getState().photoBgRemover;
            const selectedDownloadList = getState().common.selectedDownloadList;
            const isAutoRemoveBackground = curMenuIndex === 0;
            let downloadList;
            if (isAutoRemoveBackground) {
                // 可能下载多个图片
                if (autoBgImageDataList.length > 1) {
                    downloadList = autoBgImageDataList.filter(
                        item => selectedDownloadList.findIndex(sItem => sItem.id === item.id) !== -1,
                    );
                } else {
                    downloadList = autoBgImageDataList;
                }
            } else {
                downloadList = [customEditBgImageData];
            }

            dispatch(setSliceBatchDownloadLoadingAction(true));
            FJPhotoBgRemoverStoreSingleton.downloadImageList(downloadList, isAutoRemoveBackground)
                .catch(e => console.log(e))
                .finally(() => {
                    dispatch(setSliceBatchDownloadLoadingAction(false));
                });
        };
    },
    //#endregion

    //#region 添加，应用到编辑页
    addMultipleMediaToMediaLibraryAction: function (options) {
        return (dispatch, getState) => {
            const { curMenuIndex, autoBgImageDataList = [], customEditBgImageData } = getState().photoBgRemover;
            const isAutoRemoveBackground = curMenuIndex === 0;
            const items = isAutoRemoveBackground ? autoBgImageDataList : [customEditBgImageData];
            FJPhotoBgRemoverStoreSingleton.getDownloadImageBlobList(items, isAutoRemoveBackground).then(blobList => {
                dispatch(FJActionEditPage.addMultipleMediaToMediaLibraryAction(blobList, options));
            });
        };
    },
    applyToEditPageAction: function () {
        return (dispatch, getState) => {
            const {
                curMenuIndex,
                curSelectAutoBgImageIndex,
                autoBgImageDataList = [],
                customEditBgImageData,
            } = getState().photoBgRemover;
            const isAutoRemoveBackground = curMenuIndex === 0;
            const selectedItem = isAutoRemoveBackground
                ? autoBgImageDataList[curSelectAutoBgImageIndex]
                : customEditBgImageData;
            FJPhotoBgRemoverStoreSingleton.getDownloadImageBlobList([selectedItem], isAutoRemoveBackground).then(
                blobList => {
                    const blob = blobList[0];
                    let options = { size: blob.imageSize };
                    dispatch(FJActionEditPage.applyToEditPageAction(blob, options));
                },
            );
        };
    },
    //#endregion

    //#region  缩略图更新相关
    /**
     * @desc 添加缩略图列表
     * @param {{id: string, status: string, thumbnailUrl: string}} thumbnail
     * @returns
     */
    addThumbnailAction: function (thumbnail) {
        return async (dispatch, getState) => {
            const thumbnailList = getState().photoBgRemover.thumbnailList;
            const newThumbnailList = FJUtil.deepClone(thumbnailList);

            const findIndex = thumbnailList.findIndex(item => item.id === thumbnail.id);
            if (findIndex !== -1) {
                newThumbnailList[findIndex] = thumbnail;
            } else {
                newThumbnailList.push(thumbnail);
            }

            dispatch(setSliceThumbnailList(newThumbnailList));
        };
    },

    /**
     * @desc 更新缩略图列表
     * @param {{id: string, status: string, thumbnailUrl: string}} thumbnail
     * @returns
     */
    updateThumbnailListAction: function (thumbnail) {
        return async (dispatch, getState) => {
            const isPhotoRemoveBg = getState().brushEditCommon.isPhotoRemoveBg;
            const brushEditStatus = getState().brushEditCommon.brushEditStatus;
            const headerTabIndex = getState().common.headerTabIndex;
            const isShowDownload = isPhotoRemoveBg && brushEditStatus === FJConstant.DEFAULT && headerTabIndex === 0;
            const curMenuIndex = getState().photoBgRemover.curMenuIndex;
            const isAutoRemove = curMenuIndex === 0;

            const thumbnailList = getState().photoBgRemover.thumbnailList;
            const newThumbnailList = FJUtil.deepClone(thumbnailList);

            const findIndex = newThumbnailList.findIndex(item => item.id === thumbnail.id);
            if (findIndex !== -1) {
                newThumbnailList[findIndex] = {
                    ...newThumbnailList[findIndex],
                    ...thumbnail,
                };
            }
            // TODO 当自动抠图，且有多张时，并且需要显示download按钮，则需要更新download下拉选中菜单的list
            if (isAutoRemove && thumbnailList.length > 1 && isShowDownload) {
                dispatch(setSelectedDownloadList(newThumbnailList));
            }

            dispatch(setSliceThumbnailList(newThumbnailList));
        };
    },
    //#endregion

    /**
     * @desc 上传背景
     * @returns
     */
    uploadBgAction: function (file) {
        return async (dispatch, getState) => {
            const flexClipBgLoadStatus = getState().photoBgRemover.flexClipBgLoadStatus;
            if (flexClipBgLoadStatus === FJConstant.LOADING) return;

            const { status, errorType } = _judgeFile(file);
            if (!status) {
                _showTipByErrorType(errorType);
                return;
            }

            const fileId = await FJUtil.hashEncode(file);
            const customUploadBgFileList = getState().photoBgRemover.customUploadBgFileList;
            const sameFile = customUploadBgFileList.find(item => item.id === fileId);

            if (sameFile) {
                FJMessageStore.addMessage(FJLocalStore._('file-already-exists-please-select-other-files'), 'error');
                return;
            }

            const imgData = await FJCompressedImageStore.compressImageByFile(file);

            if (!imgData) {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
                return;
            }
            imgData.id = fileId;

            dispatch(setSliceCustomUploadBgFileList([imgData, ...customUploadBgFileList]));

            dispatch(
                this.setBackgroundImageAction({
                    url: imgData.src,
                    isCustomUpload: true,
                    id: fileId,
                }),
            );
        };
    },

    _openMessageModel: function (cancelCallback, applyCallback) {
        return async dispatch => {
            dispatch(
                FJActionModal.showWarningModalAction({
                    title: FJLocalStore._('upload-again-and-the-current-changes-will-be-lost'),
                    content: FJLocalStore._('upload-again-and-the-current-changes-will-be-lost-desc'),
                    footerDates: [
                        {
                            btnType: FJConstant.SUBMIT,
                            btnText: FJLocalStore._('upload'),
                            btnCallback: async () => {
                                applyCallback && applyCallback();
                            },
                        },
                        {
                            btnType: FJConstant.CANCEL,
                            btnText: FJLocalStore._('cancel'),
                            btnCallback: () => {
                                cancelCallback && cancelCallback();
                            },
                        },
                    ],
                    closeCallback: cancelCallback,
                }),
            );
        };
    },

    /**
     * @desc 保存并退出去背景编辑
     * @returns
     */
    _savaAndExitBrushEdit: function () {
        return async (dispatch, getState) => {
            const isPhotoRemoveBg = getState().brushEditCommon.isPhotoRemoveBg;
            const curBrushType = getState().brushEditCommon.curBrushType;
            const isAutoBg = getState().photoBgRemover.curMenuIndex === 0;

            if (isPhotoRemoveBg && curBrushType !== MOUSE_EVENT_TYPE.NONE) {
                dispatch(FJActionBrushEditCommon.applyPhotoRemoveBgBrushAction());

                if (!isAutoBg) {
                    await dispatch(this._saveCustomEditBgImageData());
                }
            }
        };
    },

    /**
     * @desc 编辑历史
     * @param {Object} data
     * @param {Function} callback
     * @returns
     */
    editPhotoBgRemoverHistoryAction: function (data, callback) {
        return async (dispatch, getState) => {
            // 更新编辑画布
            const ___updateEditCanvas = async newAutoBgImageData => {
                dispatch(
                    FJActionBrushEditCommon.setEditImageAction({
                        src: newAutoBgImageData.originImgUrl,
                        width: newAutoBgImageData.width,
                        height: newAutoBgImageData.height,
                    }),
                );
            };

            const brushEditStatus = getState().brushEditCommon.brushEditStatus;

            if (
                brushEditStatus === FJConstant.LOADING ||
                brushEditStatus === FJConstant.GENERATING ||
                brushEditStatus === FJConstant.START
            ) {
                FJMessageStore.addMessage(FJLocalStore._('generation-task-already-exists'), 'error');
                callback && callback();
                return;
            }

            const isCustomRemoveBg = data.isCustomRemoveBg;

            const newCurMenuIndex = isCustomRemoveBg ? 1 : 0;

            const { hasUndo, hasRedo } = dispatch(this.getUndoRedoAction());
            callback && callback();
            if (!isCustomRemoveBg) {
                const __upload = async () => {
                    try {
                        let autoBgImageDataList = [
                            {
                                ...DEFAULT_AUTO_EDIT_BG_IMAGE_DATA,
                                id: data.id,
                                originImgUrl: '',
                                taskStatus: FJConstant.START,
                                width: data.width,
                                height: data.height,
                            },
                        ];
                        const maskData = await FJPhotoBgRemoverStoreSingleton.imageToMaskData(data.imgUrl);
                        const maskKey = await FJPhotoBgRemoverStoreSingleton.saveAutoMaskData(maskData, null, true);

                        dispatch(this.switchCurMenuIndex(newCurMenuIndex));
                        // 清空列表
                        dispatch(setSliceAutoBgImageDataList(FJUtil.deepClone(autoBgImageDataList)));
                        dispatch(FJActionBrushEditCommon.setCurBrushTypeAction(MOUSE_EVENT_TYPE.NONE));
                        dispatch(this.changeCurSelectAutoBgImage(0));
                        dispatch(setSliceBrushEditStatus(FJConstant.START));
                        FJPhotoBgRemoverStoreSingleton.clearUndoRedo();

                        const autoBgImageData = autoBgImageDataList[0];

                        const newAutoBgImageData = {
                            ...autoBgImageData,
                            maskKey: maskKey,
                            resetMaskKey: maskKey,
                            originImgUrl: data.originalUrl + '?v=' + Date.now(),
                            taskStatus: FJConstant.DEFAULT,
                        };

                        autoBgImageDataList[0] = newAutoBgImageData;
                        dispatch(setSliceAutoBgImageDataList(FJUtil.deepClone(autoBgImageDataList)));
                        ___updateEditCanvas(newAutoBgImageData);
                    } catch (e) {
                        FJMessageStore.addMessage(FJLocalStore._('unknown-error-please-try-again'), 'error');
                    } finally {
                        callback && callback();
                    }
                };

                const autoBgImageDataList = getState().photoBgRemover.autoBgImageDataList;
                if (autoBgImageDataList && autoBgImageDataList.length > 0 && (hasUndo || hasRedo)) {
                    // 如果列表长度大于0，则弹出消息提示
                    dispatch(this._openMessageModel(callback, __upload));
                } else {
                    __upload();
                }
            } else {
                const __upload = async () => {
                    try {
                        const customEditBgImageData = {
                            ...DEFAULT_CUSTOM_EDIT_BG_IMAGE_DATA,
                            id: data.id,
                            originImgUrl: '',
                            width: data.width,
                            height: data.height,
                            isPhotoRemoveBg: true,
                        };

                        const maskData = await FJPhotoBgRemoverStoreSingleton.imageToMaskData(data.imgUrl);

                        const maskKey = await FJPhotoBgRemoverStoreSingleton.saveCustomMaskData(
                            maskData,
                            customEditBgImageData.maskKey,
                            true,
                        );

                        dispatch(this.switchCurMenuIndex(newCurMenuIndex));
                        dispatch(setSliceIsPhotoRemoveBg(true));
                        dispatch(setSliceCustomEditBgImageData(FJUtil.deepClone(customEditBgImageData)));
                        dispatch(FJActionBrushEditCommon.setCurBrushTypeAction(MOUSE_EVENT_TYPE.NONE));
                        dispatch(setSliceBrushEditStatus(FJConstant.START));
                        ___updateEditCanvas(customEditBgImageData);

                        customEditBgImageData.maskKey = maskKey;
                        customEditBgImageData.resetMaskKey = maskKey;
                        customEditBgImageData.originImgUrl = data.originalUrl + '?v=' + Date.now();
                        customEditBgImageData.taskStatus = FJConstant.DEFAULT;

                        dispatch(setSliceCustomEditBgImageData(FJUtil.deepClone(customEditBgImageData)));
                        ___updateEditCanvas(customEditBgImageData);
                    } catch (error) {
                        FJMessageStore.addMessage(FJLocalStore._('unknown-error-please-try-again'), 'error');
                    } finally {
                        callback && callback();
                    }
                };

                const customEditBgImageData = getState().photoBgRemover.customEditBgImageData;
                const isPhotoRemoveBg = getState().brushEditCommon.isPhotoRemoveBg;
                if (customEditBgImageData && (hasUndo || hasRedo) && isPhotoRemoveBg) {
                    dispatch(this._openMessageModel(callback, __upload));
                } else {
                    __upload();
                }
            }
        };
    },

    /**
     * @desc 自动去背景重试
     * @returns
     */
    retryAction: function () {
        return async (dispatch, getState) => {
            const isAutoBg = getState().photoBgRemover.curMenuIndex === 0;
            if (isAutoBg) {
                const curSelectAutoBgImageIndex = getState().photoBgRemover.curSelectAutoBgImageIndex;
                const autoBgImageDataList = getState().photoBgRemover.autoBgImageDataList;

                const autoBgImageData = autoBgImageDataList[curSelectAutoBgImageIndex];

                if (autoBgImageData.taskStatus === FJConstant.ERROR) {
                    const _errorCallback = (autoEditBgImageData, index) => {
                        FJMessageStore.addMessage(FJLocalStore._('unknown-error-please-try-again'), 'error');
                        dispatch(this._autoRequestErrorCallback(autoEditBgImageData, index));
                        dispatch(FJActionCommon.updateUserInfoAction());
                        FJUtil.updateLoginCreditNumber();
                    };

                    const _successCallback = (newAutoBgImageData, index) => {
                        dispatch(this._autoRequestSuccessCallback(newAutoBgImageData, index));
                        dispatch(FJActionCommon.updateUserInfoAction());
                        FJUtil.updateLoginCreditNumber();
                    };

                    const newAutoBgImageDataList = FJUtil.deepClone(autoBgImageDataList);
                    const newAutoBgImageData = newAutoBgImageDataList[curSelectAutoBgImageIndex];

                    newAutoBgImageData.taskStatus = FJConstant.START;
                    newAutoBgImageData.originImgUrl = '';
                    newAutoBgImageDataList[curSelectAutoBgImageIndex] = newAutoBgImageData;

                    dispatch(setSliceAutoBgImageDataList(FJUtil.deepClone(newAutoBgImageDataList)));
                    dispatch(this._updateEditCanvas(newAutoBgImageData, curSelectAutoBgImageIndex));

                    if (!autoBgImageData.originImgUrl.includes(FJS3Config.S3_SERVER_HOST)) {
                        const s3Url = await FJImageStore.uploadFilesByUrl([autoBgImageData.originImgUrl]);

                        if (!s3Url || s3Url[0] === '') {
                            newAutoBgImageData.originImgUrl = autoBgImageData.originImgUrl;
                            _errorCallback(newAutoBgImageData, curSelectAutoBgImageIndex);
                            return;
                        }

                        newAutoBgImageData.originImgUrl = s3Url[0];
                    } else {
                        newAutoBgImageData.originImgUrl = autoBgImageData.originImgUrl;
                    }

                    _request(newAutoBgImageData, curSelectAutoBgImageIndex, _errorCallback, _successCallback);
                }
            }
        };
    },

    initFlexClipBackgroundData: function () {
        return async (dispatch, getState) => {
            const flexClipBgLoadStatus = getState().photoBgRemover.flexClipBgLoadStatus;
            if (flexClipBgLoadStatus === FJConstant.SUCCESS || flexClipBgLoadStatus === FJConstant.LOADING) {
                return;
            }

            try {
                dispatch(setSliceFlexClipBackgroundLoadStatus(FJConstant.LOADING));
                const response = await fetch(FJConfig.backgroundPhotoListJsonPath);
                const backgroundPhotoList = await response.json();

                dispatch(setSliceBackgroundPhotoList(backgroundPhotoList));
                dispatch(setSliceFlexClipBackgroundLoadStatus(FJConstant.SUCCESS));
            } catch (error) {
                dispatch(setSliceFlexClipBackgroundLoadStatus(FJConstant.ERROR));
            }
        };
    },

    /**
     * @desc 切换菜单索引
     * @param {number} index
     * @returns
     */
    switchCurMenuIndex: function (index) {
        return async (dispatch, getState) => {
            const curMenuIndex = getState().photoBgRemover.curMenuIndex;
            if (index === curMenuIndex || _switchMenuLoading) return;
            _switchMenuLoading = true;

            if (index === 0) {
                await dispatch(this._savaAndExitBrushEdit());
                const isPhotoRemoveBg = getState().brushEditCommon.isPhotoRemoveBg;
                !isPhotoRemoveBg && (await dispatch(this._saveCustomEditBgImageData()));

                FJViewCanvasSingleton.clear();
                dispatch(FJActionBrushEditCommon.endPhotoRemoveBgAction());

                const autoBgImageDataList = getState().photoBgRemover.autoBgImageDataList;
                const curSelectAutoBgImageIndex = getState().photoBgRemover.curSelectAutoBgImageIndex;

                const autoBgImageData = autoBgImageDataList[curSelectAutoBgImageIndex];

                const editImageInfo = autoBgImageData
                    ? {
                          src: autoBgImageData.originImgUrl,
                          width: autoBgImageData.width,
                          height: autoBgImageData.height,
                      }
                    : null;

                if (editImageInfo) dispatch(setSliceBrushEditStatus(FJConstant.START));
                dispatch(FJActionBrushEditCommon.setEditImageAction(editImageInfo));
            } else {
                await dispatch(this._savaAndExitBrushEdit());
                FJViewCanvasSingleton.clear();
                dispatch(FJActionBrushEditCommon.endPhotoRemoveBgAction());

                dispatch(FJActionBrushEditCommon.setCurBrushTypeAction(MOUSE_EVENT_TYPE.NONE));
                const customEditBgImageData = getState().photoBgRemover.customEditBgImageData;

                const editImageInfo =
                    customEditBgImageData && customEditBgImageData.originImgUrl
                        ? {
                              src: customEditBgImageData.originImgUrl,
                              width: customEditBgImageData.width,
                              height: customEditBgImageData.height,
                          }
                        : null;

                if (customEditBgImageData && customEditBgImageData.isPhotoRemoveBg) {
                    dispatch(setSliceIsPhotoRemoveBg(true));
                }

                if (!editImageInfo) {
                    dispatch(setSliceBrushEditStatus(FJConstant.DEFAULT));
                }
                dispatch(FJActionBrushEditCommon.setEditImageAction(editImageInfo));
            }

            dispatch(setSliceCurMenuIndex(index));
            setTimeout(() => {
                _switchMenuLoading = false;
            }, 300);
        };
    },

    /**
     * @desc 重置mask
     * @returns
     */
    resetMaskAction: function () {
        return async (dispatch, getState) => {
            const isAutoBg = getState().photoBgRemover.curMenuIndex === 0;
            if (isAutoBg) {
                const autoBgImageDataList = getState().photoBgRemover.autoBgImageDataList;
                const curSelectAutoBgImageIndex = getState().photoBgRemover.curSelectAutoBgImageIndex;
                const autoBgImageData = autoBgImageDataList[curSelectAutoBgImageIndex];

                const maskData = await FJPhotoBgRemoverStoreSingleton.getAutoLocalForageItem(
                    autoBgImageData.resetMaskKey,
                );
                const bgData = {
                    backgroundType: BACKGROUND_TYPE.TRANSPARENT,
                    backgroundImage: null,
                    backgroundColor: null,
                };
                const strokeData = {
                    type: 'none',
                };

                dispatch(this.addUndoAction());

                FJViewCanvasSingleton.setMaskData(maskData);
                FJViewCanvasSingleton.reset();
                await dispatch(this._saveAutoBgImageData(autoBgImageData.resetMaskKey, 'maskKey', false, true));
                await dispatch(this._saveAutoBgImageData(bgData, 'bgData', false, true));
                await dispatch(this._saveAutoBgImageData(strokeData, 'strokeData', false, true));
            } else {
                const customEditBgImageData = getState().photoBgRemover.customEditBgImageData;

                const maskData = await FJPhotoBgRemoverStoreSingleton.getCustomLocalForageItem(
                    customEditBgImageData.resetMaskKey,
                );

                FJViewCanvasSingleton.reset();
                FJViewCanvasSingleton.setMaskData(maskData);
                FJViewCanvasSingleton.updateView();
                FJViewCanvasSingleton.draw();
                dispatch(this._saveCustomEditBgImageData());
            }
        };
    },

    /**
     * @desc 初始化图片去背景项目
     */
    initPhotoRemoveBgProjectAction: function () {
        return async dispatch => {
            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
            if (recIdInfo) {
                const url = location.origin + location.pathname;
                FJUtil.changeLocation(url);
                window.localStorage.removeItem(recId);
                const { fileList, avator } = recIdInfo;

                if (fileList) {
                    const fileInfo = fileList[0]?.info;
                    if (!fileInfo) return;
                    const data = await FJLoadLocalforageStore.getItem(fileList[0].key);
                    const file = new File([data.data], fileInfo.name, { type: fileInfo.type });
                    dispatch(this.uploadAutoBgImageFile([file]));
                } else if (avator) {
                    const blob = await FJUtil.getBlobByUrl(avator);
                    dispatch(this.uploadAutoBgImageFile([blob]));
                }
            }
        };
    },
};

export default FJActionPhotoBgRemover;
